import React from 'react';
import styled from 'styled-components';
import {SchemaWithoutScreen} from '../../types/Schema';
import {useIntl} from 'react-intl';
import {DiffField} from './DiffField';
import {fieldLabel, headerCell} from './styles';
import {colors} from '../../styles';

type Props = {
  schema: SchemaWithoutScreen;
  fields: DiffField[];
};

export const DiffHeader: React.FC<Props> = (props) => {
  const intl = useIntl();

  return (
    <Container>
      <tr>
        <LabelCell>
          {intl.formatMessage({
            id: 'Widget.ResourceDiff.Header.Field',
            defaultMessage: 'Field',
          })}
        </LabelCell>
        <Cell>
          {intl.formatMessage({
            id: 'Widget.ResourceDiff.Header.OldValue',
            defaultMessage: 'Before',
          })}
        </Cell>
        <Cell>
          {intl.formatMessage({
            id: 'Widget.ResourceDiff.Header.NewValue',
            defaultMessage: 'After',
          })}
        </Cell>
      </tr>
    </Container>
  );
};

const Container = styled.thead`
  & th + th {
    border-left: 1px solid ${colors.bodyColor};
  }
`;

const LabelCell = styled.th`
  ${fieldLabel}
  ${headerCell}
`;

const Cell = styled.th`
  ${headerCell}
`;
